import { render, staticRenderFns } from "./DonutChart32.vue?vue&type=template&id=f82eebc8&scoped=true&"
import script from "./DonutChart32.vue?vue&type=script&lang=js&"
export * from "./DonutChart32.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82eebc8",
  null
  
)

export default component.exports